import { render } from "./leaderBoard.vue?vue&type=template&id=3fc5e75e&scoped=true"
import script from "./leaderBoard.vue?vue&type=script&lang=js"
export * from "./leaderBoard.vue?vue&type=script&lang=js"

import "./leaderBoard.vue?vue&type=style&index=0&id=3fc5e75e&scoped=true&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/nosecape-leaderboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc5e75e"]])

export default __exports__